/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2021-02-19 16:25:47
 * @LastEditors: Connor
 * @Description: 
 * @FilePath: \thework\tofba-client\src\api\user.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/author/getToken',
    method: 'post',
    data
  })
}

//获取客户信息
export function getInfo(data) {
  //console.log('%ctoken: ', 'color: MidnightBlue; background: Aquamarine;', token);
  return request({
    url: '/customer/getInfo',
    method: 'post',
    data,
  })
}
//修改密码
export function updatePassword(data) {
  //console.log('%ctoken: ', 'color: MidnightBlue; background: Aquamarine;', token);
  return request({
    url: '/customer/updatePassword',
    method: 'post',
    data,
  })
}

export function logout(token) {
  return request({
    url: '/author/removeToken',
    method: 'post',
    params: { token }
  })
}
// 设置客户自定义面单标签logo和文字
export function customerSetLogo(data) {
  return request({
    url: '/customer/saveLogo',
    method: 'post',
    data
  })
}
// 账单异常原因
export function billExceptionReason(data) {
  return request({
    url: '/api/amazon/problem/cancelConfirmBill',
    method: 'get',
    params: data
  })
}
// 获取宁波系统token
export function getNbToken(data) {
  return request({
    url: '/customer/redirectLogin',
    method: 'post'
  })
}

// 记录std登录次数
export function recordSdLoginNumber(data){
  return request({
    url: '/customer/std/addNumberOfLogins',
    method: 'post',
    data
  })
}